import LockIcon from "@mui/icons-material/Lock";
import { Box, FlexColumn, FlexRow } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import TextField from "designSystem/components/textfield/TextField";
import { observer } from "mobx-react-lite";
import React from "react";
import ChannelForm from "src/Chat/component/ChannelForm";
import ChatFormField from "src/Chat/component/ChatFormField";
import { useChannelNameStyles } from "src/Chat/component/styles";
import HashIcon from "../icon/HashIcon";
import { useSlackStore } from "./SlackStore";

const NameField = observer(() => {
	const locale = useLocale();
	const store = useSlackStore();
	const { nameIcon, nameInput } = useChannelNameStyles();

	const {
		channelNameErrorResource,
		setNewChannelName,
		newChannelDisplayName,
		channelIsPrivate,
	} = store;

	return (
		<ChatFormField error={locale.resource(channelNameErrorResource)} label={locale.resource("ChannelNameLabel")}>
			<Box position="relative">
				<TextField
					InputProps={{ sx: nameInput }}
					fullWidth
					onChange={setNewChannelName}
					value={newChannelDisplayName}
				/>
				{channelIsPrivate ? <LockIcon sx={nameIcon} /> : <HashIcon sx={nameIcon} />}
			</Box>
		</ChatFormField>
	);
});

const AddChannel: React.FunctionComponent = observer(() => {
	const store = useSlackStore();
	const {
		fetchUsers,
		closeRightPane,
		handleOnBack,
		readyToCreateChannel,
	} = store;

	React.useEffect(() => {
		fetchUsers();
	}, []);

	return (
		<FlexColumn>
			<FlexRow>
				<PaneHeader
					back
					onBack={handleOnBack}
					onClose={closeRightPane}
					titleRes="AddNewChannelTitle"
				/>
			</FlexRow>
			<ChannelForm
				NameComponent={<NameField />}
				dataReady={readyToCreateChannel}
				store={store}
			/>
		</FlexColumn>
	);
});

export default AddChannel;